import React, { useState } from "react";

import { Link, useLocation, useHistory } from "react-router-dom";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

/// Image
import profile from "../../../images/profile/17.jpg";
import avatar from "../../../images/avatar/1.jpg";
import { Dropdown } from "react-bootstrap";
import * as constants from '../../../utils/Constants'

const Header = ({ toggle, onProfile, onNotification, onClick }) => {
  const history = useHistory()
  var path = window.location.pathname.split("/");
  var name = path[path.length - 1].split("-");
  const loggedInUser = JSON.parse(localStorage.getItem('user'))
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
  var finalName = filterName.includes("app")
    ? filterName.filter((f) => f !== "app")
    : filterName.includes("ui")
      ? filterName.filter((f) => f !== "ui")
      : filterName.includes("uc")
        ? filterName.filter((f) => f !== "uc")
        : filterName.includes("basic")
          ? filterName.filter((f) => f !== "basic")
          : filterName.includes("jquery")
            ? filterName.filter((f) => f !== "jquery")
            : filterName.includes("table")
              ? filterName.filter((f) => f !== "table")
              : filterName.includes("page")
                ? filterName.filter((f) => f !== "page")
                : filterName.includes("email")
                  ? filterName.filter((f) => f !== "email")
                  : filterName.includes("ecom")
                    ? filterName.filter((f) => f !== "ecom")
                    : filterName.includes("chart")
                      ? filterName.filter((f) => f !== "chart")
                      : filterName.includes("editor")
                        ? filterName.filter((f) => f !== "editor")
                        : filterName;

  const logout = () => {
    history.push('/page-login');
    localStorage.removeItem('user')
  }

  const agentProfile = () => {
    if (loggedInUser?.roles === 'Recruitment Agent') {
      fetch(`${constants.GetRecruitingAgentByIdUrl}/${loggedInUser.userId}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${loggedInUser.sessionToken}`,
        }
      })
        .then(response => response.json())
        .then((res) => {
          history.push({
            pathname: '/agent-profile',
            state: res.data
          })
        })
    }
  }

  const [state, setState] = useState(useLocation().state)
  const handleProfileImage = (imageId) => {
    if (loggedInUser?.roles === 'Recruitment Agent') {
      fetch(`${constants.GetRecruitingAgentByIdUrl}/${loggedInUser?.userId}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${loggedInUser.sessionToken}`,
        }
      })
        .then(response => response.json())
        .then((res) => {
          if (res.data.imageId) {
            var url = `${constants.AgentViewProfileUrl}/${res.data.imageId}`;
            if (url) {
              document.getElementById('headerLoagoid').setAttribute('src', url)
            }
          }
        })
    }
  }
  // 401 unauthorized token
  const { fetch: originalFetch } = window;
  window.fetch = async (...args) => {
    let [resource, config] = args;
    // request interceptor here  
    const response = await originalFetch(resource, config);
    // response interceptor here   
    if (response.status == 401) {

      setTimeout(() => {
        window.location.href = '/page-login';
      }, 3000);
    }
    else {
      return response;
    }
  };

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div
                className="dashboard_bar"
                style={{ textTransform: "capitalize" }}
              >
                {finalName.join(" ").length === 0
                  ? "Dashboard"
                  : finalName.join(" ")}
              </div>
            </div>

            {loggedInUser?.roles === 'Recruitment Agent' && loggedInUser?.agentStatus === 'Unverified' &&
              <div style={{ backgroundColor: '#00ADEE', marginTop: 71, marginBottom: 3, color: 'white', paddingBottom: '9px', border: 'none', padding: '9px' }}>Note: Please Complete your Profile First and Wait For Approval !</div>
            }

            <ul className="navbar-nav header-right">
              <Dropdown className="nav-item dropdown header-profile ml-sm-4 ml-2">
                <Dropdown.Toggle
                  as="a"
                  to="#"
                  variant=""
                  className="nav-link i-false c-pointer"
                  data-toggle='dropdown'
                >
                  <div className="header-info">
                    <span className="text-black">
                      <strong>{loggedInUser?.userName}</strong>
                    </span>
                    <p className="fs-12 mb-0">{loggedInUser?.roles}</p>
                  </div>
                  {/* {loggedInUser?.roles === 'Admin' &&
                    <img src={profile} width={20} alt="" />
                  } */}
                  {loggedInUser?.roles === 'Recruitment Agent' &&
                    <img id="headerLoagoid" src={handleProfileImage(state?.imageId)} width={20} alt="" />
                  }
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-2">
                  {loggedInUser?.roles === 'Recruitment Agent' &&
                    <Dropdown.Item>
                      <button className="dropdown-item ai-icon"
                        type="button"
                        onClick={agentProfile}>
                        <svg
                          id="icon-user1"
                          xmlns="http://www.w3.org/2000/svg"
                          className="text-primary"
                          width={18}
                          height={18}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                          <circle cx={12} cy={7} r={4} />
                        </svg>
                        <span className="ml-2">Profile </span>
                      </button>
                    </Dropdown.Item>
                  }
                  <Dropdown.Item>
                    <button className="dropdown-item ai-icon"
                      type="button"
                      onClick={logout}>
                      <svg
                        id="icon-logout"
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-danger"
                        width={18}
                        height={18}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                        <polyline points="16 17 21 12 16 7" />
                        <line x1={21} y1={12} x2={9} y2={12} />
                      </svg>
                      <span className="ml-2">Logout </span>
                    </button>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div >
      {/* <ToastContainer /> */}
    </div >
  );
};

export default Header;